<template lang="pug">
	.creative-create-editable-playable(v-if="showed")
		.card
			.card-header
				span Create AI playable creative
			.card-body.collapse.show
				.form-group.separator
					label.col-form-label AI playable creative title
						.controls
							input.form-control.title(size="16" type="text" v-model="title" @keyup.enter="create()")
				.form-horizontal
					.form-actions
						button.btn.btn-primary(type="submit" :class="{disabled: !title}" v-on:click="create()")
							i.fa.fa-plus
							| &nbsp;&nbsp;Create
						button.btn.btn-dark(type="button" v-on:click="close()") Close
</template>

<script>

	import Screen 				from './../../mixins/screen'

	export default {
		name: "EditablePlayableCreateCreative",
		mixins: [Screen],
		screen: {
			events: {
				"Show EditablePlayableCreateCreative": function() {

					this.title = '';

				}
			}
		},
		data() {
			return {
				showed: false,
				title: ''
			};
		},
		methods: {
			collectData() {

			},
			close() {

				this.hide();

			},
			create() {

				if (!this.title) return;

				Server.sendToSocket({
					CreateCreative: {
						type: 'editable-playable',
						title: this.title,
						workspace: Layout.workspace,
						publisherId: Publisher.SelectedPublisher.id
					}
				});

				this.hide();

			}
		}
	}
</script>

<style lang="sass">

	.creative-create-editable-playable
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.card
			width: 550px
			position: absolute
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			height: 200px
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			.btn-ghost-dark, .btn-dark
				float: right
				color: #fff

			.form-actions
				position: absolute
				right: 19px
				bottom: 20px
				width: calc(100% - 40px)

			.col-form-label
				display: flex
				flex-direction: row
				line-height: 32px
				justify-content: space-between

				.form-control
					width: 350px

</style>
